import Vue from 'vue'
import VueRouter from 'vue-router'
import config from "@/config";
import OrderComplete from "@/components/OrderComplete";
import OrderFail from "@/components/OrderFail";
import MagicLink from "../desktopViews/MagicLink.vue";
import ChatView from "@/desktopViews/ChatView.vue";

Vue.use(VueRouter);

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

// @todo check if is mobile
const isMobile = mobileCheck();

if(location.host === config.mainHost || location.host === 'delicity.com' || location.host === 'localhost:8080'){
  var routes = [
    {
      path: '/',
      name: 'catalog',
      meta: {
        title: 'Delicity : Nos restaurants'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Home');
        }
        else{
          return import('@/desktopViews/Home');
        }
      }
    },
    {
      path: '/chat',
      component: ChatView
    },
    {
      path: '/paris',
      component: function (){
        location.href = '/?lat=48.86057601762773&lng=2.3414535321003282&addressName=Paris';
      },
    },
    {
      path: '/user/:username',
      component: function (){
        // Get current username
        let username = window.location.pathname.split('/')[2];
        // Redirect to user page
        location.href = 'https://s.delicity.com/u/'+username;
      },
    },
    {
      path: '/:slug/booking',
      component: function (){
        // Get current username
        let slug = window.location.pathname.split('/')[1];
        // Redirect to user page
        location.href = 'https://booking.delicity.com/'+slug;
      },
    },
    {
      path: '/merchant/un/:placeId',
      component: function (){
        // Get current username
        let placeId = window.location.pathname.split('/')[3];
        // Redirect to user page
        location.href = 'https://s.delicity.com/merchant/un/'+placeId;
      },
    },
    {
      path: '/signin/magicLink_app',
      component: MagicLink
    },
    {
      path: '/nice',
      component: function (){
        location.href = '/?lat=43.70094500049188&lng=7.269939983920888&addressName=Nice';
      },
    },
    {
      path: '/pau',
      component: function (){
        location.href = '/?lat=43.303019&lng=-0.370842&addressName=Pau';
      }
    },
    {
      path: '/nantes',
      component: function (){
        location.href = '/?lat=47.218371&lng=-1.553621&addressName=Nantes';
      },
    },
    {
      path: '/bordeaux',
      component: function (){
        location.href = '/?lat=44.837789&lng=-0.57918&addressName=Bordeaux';
      }
    },
    {
      path: '/toulouse',
      component: function (){
        location.href = '/?lat=43.60020799922107&lng=1.4365859999682653&addressName=Toulouse';
      }
    },
    {
      path: '/lyon',
      component: function (){
        location.href = '/?lat=45.764043&lng=4.835659&addressName=Lyon';
      }
    },
    {
      path: '/limoges',
      component: function (){
        location.href = '/?lat=45.8304933662216&lng=1.2584824068986644&addressName=Limoges';
      }
    },
    {
      path: '/toulouse',
      component: function (){
        location.href = '/?lat=43.59930031811336&lng=1.4388404600279807&addressName=Toulouse';
      }
    },
    {
      path: '/order_complete',
      name: 'order_complete',
      meta: {
        title: 'Commande validée'
      },
      component: OrderComplete,
    },
    {
      path: '/order_fail',
      name: 'order_fail',
      meta: {
        title: 'Erreur de paiement'
      },
      component: OrderFail,
    },
    {
      path: '/categories',
      name: 'categories',
      meta: {
        title: 'Categories'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Categories');
        }
        else{
          return false;
        }
      }
    },
    {
      path: '/:merchantSlug/summary',
      name: 'summary',
      meta: {
        title: 'Delicity : Connexion'
      },
      component: function (){
        if(isMobile){
          return false;
        }
        else{
          return import('@/desktopViews/Summary');
        }
      }
    },
    {
      path: '/:merchantSlug/checkout/:orderToken/:shareToken?',
      name: 'checkout',
      meta: {
        title: 'Votre commande'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Checkout');
        }
        else{
          return import('@/desktopViews/Checkout');
        }
      }
    },
    {
      path: '/ano_account',
      name: 'ano_account',
      meta: {
        title: 'Enregistrer votre compte'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Anonymous/AnonymousMigration');
        }
        else{
          //return import('@/desktopViews/Checkout');
        }
      }
    },
    {
      path: '/ano_account/success',
      name: 'ano_account_success',
      meta: {
        title: 'Félicitations !'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Anonymous/AnonymousSuccess');
        }
        else{
          //return import('@/desktopViews/Checkout');
        }
      }
    },
    {
      path: '/:merchantSlug',
      name: 'merchant',
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Merchant');
        }
        else{
          return import('@/desktopViews/Merchant');
        }
      }
    }
  ]
}
else{
  var routes = [
    {
      path: '/checkout/:orderToken/:shareToken?',
      name: 'checkout',
      meta: {
        title: 'Votre commande'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Checkout');
        }
        else{
          return import('@/desktopViews/Checkout');
        }
      }
    },
    {
      path: '/ano_account',
      name: 'ano_account',
      meta: {
        title: 'Enregistrer votre compte'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Anonymous/AnonymousMigration');
        }
        else{
          //return import('@/desktopViews/Checkout');
        }
      }
    },
    {
      path: '/ano_account/success',
      name: 'ano_account_success',
      meta: {
        title: 'Félicitations !'
      },
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Anonymous/AnonymousSuccess');
        }
        else{
          //return import('@/desktopViews/Checkout');
        }
      }
    },
    {
      path: '/',
      name: 'home',
      component: function (){
        if(isMobile){
          return import('@/mobileViews/MerchantHome');
        }
        else{
          return import('@/desktopViews/MerchantHome');
        }
      }
    },
    {
      path: '/order',
      name: 'merchant',
      component: function (){
        if(isMobile){
          return import('@/mobileViews/Merchant');
        }
        else{
          return import('@/desktopViews/Merchant');
        }
      }
    },
    {
      path: '/summary',
      name: 'summary',
      meta: {
        title: 'Delicity : Connexion'
      },
      component: function (){
        if(isMobile){
          return false;
        }
        else{
          return import('@/desktopViews/Summary');
        }
      }
    },
    {
      path: '/*',
      redirect: '/order'
    }
  ]

}

const router = new VueRouter({
  mode: 'history',
  routes
});


export default router
